import React, { useEffect, useState } from 'react';

import PageContent from '../../../../../components/Layout/PageContent';
import LoadingContainer from '../../../../../components/LoadingContainer';
import { TableGridApiContextProvider } from '../../../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { api } from '../../../../../core/api';
import CompaniesPageSearchPanel from '../../../../FinancialData/Companies/CompaniesPageSearchPanel';
import CompaniesFilter from '../../../../FinancialData/Companies/Filter';
import { useCompaniesDispatch } from '../../../../FinancialData/shared/CompanyContext/CompanyContext';
import { CompanyContextActionTypes } from '../../../../FinancialData/shared/CompanyContext/CompanyContext.types';
import { useErrorsDispatch } from '../../../../FinancialData/shared/ErrorContext/ErrorContext';
import { ErrorContextActionTypes } from '../../../../FinancialData/shared/ErrorContext/ErrorContext.types';
import { useFilterDispatch } from '../../../../FinancialData/shared/FinancialDataContext/FinancialDataContext';
import { FinancialDataContextActionTypes } from '../../../../FinancialData/shared/FinancialDataContext/FinancialDataContext.types';
import { SearchContextProvider } from '../../../../FinancialData/shared/SearchContext/SearchContext';
import { useBenchmarkState } from '../../../Context/BenchmarkContext';

const Refinement: React.FC = () => {
  const { activeBenchmark } = useBenchmarkState();
  const errorDispatch = useErrorsDispatch();
  const filterDispatch = useFilterDispatch();
  const companiesDispatch = useCompaniesDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchRefinementSearch = async () => {
      setIsLoading(true);
      try {
        if (activeBenchmark?.refinementSearchId) {
          const search = await api.search.getQuery(activeBenchmark.refinementSearchId);

          if (search?.searchRequest) {
            companiesDispatch({ type: CompanyContextActionTypes.ResetPagination });
            filterDispatch({
              type: FinancialDataContextActionTypes.Set,
              payload: search.searchRequest,
            });
            if (search.searchRequest.filters) {
              // perform search automatically upon loading this component
              companiesDispatch({
                type: CompanyContextActionTypes.SetIsLoadingState,
                payload: true,
              });
              companiesDispatch({
                type: CompanyContextActionTypes.SetFilterButtonClickState,
                payload: true,
              });
              filterDispatch({
                type: FinancialDataContextActionTypes.SetRequestFilterValues,
                payload: search.searchRequest.filters,
              });
            }
          }
        }
      } catch (error) {
        errorDispatch({
          type: ErrorContextActionTypes.SetError,
          payload: { error },
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchRefinementSearch();
    // Fetching only needed the first time component renders. If put activeBenchmark as dependency it will trigger
    // this useEffect whenever Search button is clicked, because we update refinementSearchId inside activeBenchmark at that time
    // And since we dispatch FinancialDataContextActionTypes.Set action it will hide the results, which we don't want
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companiesDispatch, filterDispatch, errorDispatch]);

  if (isLoading) {
    return <LoadingContainer />;
  }

  return (
    <PageContent isPageHeightAuto={false}>
      <TableGridApiContextProvider>
        <SearchContextProvider>
          <CompaniesFilter benchmarkRefinement={true} />
          <CompaniesPageSearchPanel benchmarkRefinement={true} />
        </SearchContextProvider>
      </TableGridApiContextProvider>
    </PageContent>
  );
};

export default Refinement;
